module.exports = __webpack_public_path__ + "img/art-work-icon9.c623c90d.png";